module.exports = __webpack_public_path__ + "media/images/ohap__Arrow_White-e5714bf51f1d10ba98d06b8b359d78a8.png";